import { INLINE_LINK } from '@/components/bedrock';
import { LocalizedLink as Link } from '@/components/LocalizedLink';
import { useT } from '@/core/I18nProvider';

import type { ReactElement } from 'react';

/**
 * The closing sections of `/terms` — the related-documents cross-reference
 * list and the contact section. Split from `Terms.tsx` to keep the page
 * component under the ~300-line ceiling (`.claude/rules/architecture.md`);
 * purely presentational, same keys.
 */
export function TermsFooterSections(): ReactElement {
  const { t } = useT();
  return (
    <>
      <section aria-labelledby="terms-related" className="mb-10">
        <h2
          id="terms-related"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('terms.related.heading')}
        </h2>
        <ul className="list-disc space-y-1 ps-6">
          <li>
            <Link className={INLINE_LINK} to="/trust/privacy">
              {t('terms.related.privacy.linkText')}
            </Link>{' '}
            {t('terms.related.privacy.desc')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/trust/dpa">
              {t('terms.related.dpa.linkText')}
            </Link>{' '}
            {t('terms.related.dpa.desc')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/cookies">
              {t('terms.related.cookies.linkText')}
            </Link>{' '}
            {t('terms.related.cookies.desc')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/trust/ai">
              {t('terms.related.ai.linkText')}
            </Link>{' '}
            {t('terms.related.ai.desc')}
          </li>
        </ul>
      </section>

      <section aria-labelledby="terms-contact">
        <h2
          id="terms-contact"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('terms.contact.heading')}
        </h2>
        <p>
          {t('terms.contact.before')}{' '}
          <a className={INLINE_LINK} href="mailto:admin@syncanix.com">
            admin@syncanix.com
          </a>
          {t('terms.contact.after')}
        </p>
      </section>
    </>
  );
}
